import React from 'react';

/**
 * Component to show a validation error for a form input component.
 *
 * @param error the error message
 * @return the created {@link JSX.Element}.
 * @author agd
 * @constructor
 */
export function ValidationErrorMessage({
  error
}: {
  error: string;
}): JSX.Element {
  return (
    <div role="alert" className="error-message">
      {error}
    </div>
  );
}
